import { ApiDefinition } from '../../types/api-definitions';

export interface ApiDetailState {
  currentApiDefinition: ApiDefinition | null;
  loading: boolean;
  error: string | null;
}

export const initialApiDetailState: ApiDetailState = {
  currentApiDefinition: null,
  loading: false,
  error: null,
};
